"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { Loader2, Trash2 } from "lucide-react"
import { toast } from "sonner"
import { cn } from "@/lib/utils"
import { deleteManualWatchlist } from "@/lib/api/watchlist"

interface RemoveFromWatchlistButtonProps {
  stockCode: string
  stockName: string
  className?: string
}

export function RemoveFromWatchlistButton({ stockCode, stockName, className }: RemoveFromWatchlistButtonProps) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () => deleteManualWatchlist(stockCode),
    onSuccess: () => {
      toast.success("삭제되었습니다")
      queryClient.invalidateQueries({ queryKey: ["backtest", "watchlist"] })
      queryClient.invalidateQueries({ queryKey: ["watchlist", "codes"] })
    },
    onError: () => {
      toast.error("삭제에 실패했습니다")
    },
  })

  return (
    <button
      type="button"
      disabled={mutation.isPending}
      title="워치리스트에서 삭제"
      onClick={(e) => {
        e.stopPropagation()
        if (window.confirm(`${stockName}(${stockCode})을(를) 워치리스트에서 삭제할까요?`)) {
          mutation.mutate()
        }
      }}
      className={cn(
        "inline-flex size-7 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-red-500/10 hover:text-red-400",
        className
      )}
    >
      {mutation.isPending ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <Trash2 className="size-4" />
      )}
    </button>
  )
}
